import { ref } from "vue";

export const loadedAssets = ref<{ [key: string]: string }>({});
